import React, { FunctionComponent } from "react";

import { useUrl } from "../../../stores/hooks/useUrl";
import { useShouldRenderOrderNowButton } from "../../Cart/DealerOrderModal/useShouldRenderOrderNowButton";
import { hunterTireHash } from "../QuotesDialog";
import { CriteriaInput } from "./Criteria/CriteriaInput";
import { OrdersDateSelect } from "./Date/OrdersDateSelect";
import { OrdersSizeSelect } from "./Size/OrdersSizeSelect";
import { OrderTypeSelect } from "./Type/OrderTypeSelect";

export const QuoteFilters: FunctionComponent = () => {
  const supportClientOrders = useShouldRenderOrderNowButton();
  const { hash } = useUrl();
  const isHunterTire = hash === hunterTireHash;
  return (
    <form className="p-4 flex flex-col md:flex-row gap-2" noValidate>
      {supportClientOrders && !isHunterTire && <OrderTypeSelect />}
      <OrdersSizeSelect />
      <OrdersDateSelect />
      <CriteriaInput />
    </form>
  );
};
